"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSegmentPageView = exports.SegmentPageView = exports.SegmentPageViewContext = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const logging_1 = require("@nerdwallet/logging");
const useConstant_1 = require("../../hooks/useConstant");
const segment_page_1 = require("../../segment-page");
exports.SegmentPageViewContext = (0, react_1.createContext)(null);
const segmentLogger = (0, logging_1.getLogger)('SegmentPage');
const SegmentPageView = ({ name = '', contentId, contentSource, flowName, pageType = '', children, }) => {
    const [pageViewReady, setPageViewReady] = (0, react_1.useState)(false);
    const pageViewId = (0, useConstant_1.useConstant)(() => (0, uuid_1.v4)());
    (0, react_1.useEffect)(() => {
        (0, segment_page_1.segmentPage)(name, {
            contentId,
            contentSource,
            pageviewId: pageViewId,
            pageType,
            flowName,
        });
        setPageViewReady(true);
    }, [contentId, contentSource, name, pageViewId, pageType, flowName]);
    return (react_1.default.createElement(exports.SegmentPageViewContext.Provider, { value: { pageName: name, pageType, pageViewId, pageViewReady } }, children));
};
exports.SegmentPageView = SegmentPageView;
// @TODO Fix tests so that we stop getting this error.
const useSegmentPageView = (segmentPageAttributes) => {
    const context = (0, react_1.useContext)(exports.SegmentPageViewContext);
    if (!context) {
        if (segmentPageAttributes)
            return segmentPageAttributes;
        const errMsg = 'useSegmentPageView must be used within a SegmentPageView';
        segmentLogger.error(errMsg);
        throw new Error(errMsg);
    }
    return context;
};
exports.useSegmentPageView = useSegmentPageView;
